<script>
    import rpcjs from 'rpcjs';
    const {goto} = rpcjs.props;
    import {fade} from 'svelte/transition';
    import {onMount} from 'svelte';
    let traction;
    let competition;
    let elipse;
    let elipseDeg = '-9deg';
    let text1 = 'text1After';
    let text2 = 'text2';
    let text3 = 'text3';
    let text4 = 'text4';
    let text5 = 'text5';
    let text4des;
    let text5text;
    let text5des;
    let section1;
    let section2;
    let flag = false;
    let flag2 = true;
    let tickdiv;
    let sec2divsOpacity = '1';
    let sec2divsOpacity2 = '0';
    let sec2divsOpacity3 = '0';
    let whitedivtext1;
    let whitedivtext2;
    let whitedivtext3;
    let boxlogo;
    let rowheading2;
    let boxdiv;
    let whitediv;
    /**
     */
    function rotate() {
        if (elipseDeg === '-9deg') {
            elipseDeg = '20deg';
            text1 = 'text1';
            text2 = 'text2After';
        } else if (elipseDeg === '20deg') {
            elipseDeg = '57.5deg';
            text2 = 'text2';
            text3 = 'text3After';
        } else if (elipseDeg === '57.5deg') {
            elipseDeg = '96.5deg';
            text3 = 'text3';
            text4 = 'text4After';
            text4des.style.opacity = 1;
        } else if (elipseDeg === '96.5deg') {
            elipseDeg = '123.5deg';
            text4des.style.opacity = 0;
            text4 = 'text4';
            text5 = 'text5After';
            text5text.style.marginLeft = '-1vw';
            text5des.style.bottom = '2.5vw';
        } else if (elipseDeg === '123.5deg') {
            elipseDeg = '312deg';
            elipse.style.borderTop = '6.5vw solid transparent';
            elipse.style.borderBottom = '6.5vw solid white';
            elipse.style.borderRight = '6.5vw solid transparent';
            elipse.style.borderLeft = '6.5vw solid white';
            elipse.style.transitionDuration = '2s';
            flag = true;
            traction.style.top = '-20vh';
            competition.style.top = '10vh';
        } else if (elipseDeg === '312deg') {
            elipseDeg = '315deg';
        } else if (elipseDeg === '315deg') {
            elipseDeg = '319deg';
        } else if (elipseDeg === '319deg') {
            elipseDeg = '322deg';
        }
    }
    /**
     */
    function onStart() {
        traction.style.top = '10vh';
    }
    onMount(onMountFunctio);
    /**
     */
    function onMountFunctio() {
        setTimeout(onStart, 10);
    }
    $: {
        if (flag === true) {
            setTimeout(() => {
                flag2 = false;
            }, 500);
        }
    }
    $: {
        if (flag2 === false) {
            setTimeout(() => {
                tickdiv.style.width = '74.74vw';
                tickdiv.style.left = '0vw';
            }, 2000);
        }
    }
/**
 * Adds two numbers together.
 */
    function next() {
        rotate();
        console.log(elipseDeg);
        if (elipseDeg === '315deg' && tickdiv.style.width === '74.74vw') {
            tickdiv.style.height = '14.583vw';
            tickdiv.style.borderBottomLeftRadius = '2.083vw';
            tickdiv.style.borderBottomRightRadius = '2.083vw';
            tickdiv.style.backgroundColor = '#FFCC33';
            whitedivtext1.style.left = '-20vw';
            whitedivtext2.style.left = '0vw';
            sec2divsOpacity = '0';
            sec2divsOpacity2 = '1';
            boxlogo.style.bottom = '10vw';
        } else if (elipseDeg === '319deg') {
            sec2divsOpacity2 = '0';
            sec2divsOpacity3 = '1';
            boxdiv.style.left = '17vw';
            boxdiv.style.width = '81.615vw';
            tickdiv.style.width = '81.615vw';
            boxlogo.style.left = '5.3vw';
            rowheading2.style.left = '5vw';
            whitediv.style.width = '14.427vw';
            whitedivtext2.style.left = '-20vw';
            whitedivtext3.style.left = '0vw';
        } else if (elipseDeg === '322deg') {
            goto('/mission');
        }
    }
/**
 * Adds two numbers together.
 * @param {int} e The first number.
 */
    function keycheck(e) {
        e.preventDefault();
        if (e.key == 'ArrowRight') {
            next();
        }
        if (e.key == 'ArrowLeft') {
            goto('/opusWeb3');
        }
    }
</script>

<svelte:window on:keyup={keycheck} />
<div class="maindiv">
    <div class="traction" bind:this={traction}>
        <p>TRACTION</p>
    </div>
    <div class="competition" bind:this={competition}>
        <p>COMPETITION</p>
    </div>
    <div
        class="elipse"
        style="transform: rotate({elipseDeg});"
        bind:this={elipse}
    >
        <div
            class="yellow-div"
            style="top: 3vw; left:-4.1vw;transform: rotate(14deg);"
        >
            <img
                id="yellow-div"
                src="images/traction/yellow-div.svg"
                alt=""
                width="100%"
                height="100%"
            />
        </div>
    </div>
    {#if flag2 === true}
        <section1
            out:fade
            style="opacity:1; transition-duration:0.8s; z-index:6;"
            bind:this={section1}
        >
            <div
                class="bgDiv"
                role="presentation"
                on:click={() => {
                    rotate();
                }}
            >
                <img
                    id="tractionbg"
                    src="images/traction/tractionbg.svg"
                    alt=""
                    width="100%"
                />
                <div class="hourglass">
                    <img
                        src="images/traction/img1.svg"
                        alt=""
                        width="100%"
                        height="100%"
                    />
                </div>

                <div class="person">
                    <img
                        src="images/traction/img2.svg"
                        alt=""
                        width="100%"
                        height="100%"
                    />
                </div>
                <div class="calender">
                    <img src="images/traction/img3.svg" alt="" />
                </div>
                <div class="people">
                    <img src="images/traction/img4.svg" alt="" />
                </div>
                <div class="scroll">
                    <img src="images/traction/img5.svg" alt="" />
                </div>
            </div>
            <div class={text1}>
                <p class="description">
                    <span class="heading"> 58K </span>
                    <br />
                    WAITLIST
                </p>
            </div>
            <div class={text2}>
                <p class="description">
                    <span class="heading"> 15 </span>
                    <br />
                    <span style="margin-left: -4.2vw;"> GLOBAL </span>
                    <br />
                    <span style="margin-left: -5.4vw;"> STUDENT </span>
                    <br />
                    <span style="margin-left: -10.59vw;"> AMBASSADORS </span>
                </p>
            </div>
            <div class={text3}>
                <p class="description">
                    <span class="heading"> 65 </span>
                    EVENTS
                </p>
            </div>
            <div class={text4}>
                <p class="description">
                    <span class="heading"> 35 </span>
                    EMPLOYEES
                </p>
            </div>
            <p class="text4des" style="opacity: 0;" bind:this={text4des}>
                (Technical, growth and Gov relations)
            </p>
            <div class={text5}>
                <p class="heading">3SBIR</p>
                <br />
                <p
                    class="description"
                    style="margin-left:0vw;
                    transition-duration: 1s;"
                    bind:this={text5text}
                >
                    GRANTS APPLICATIONS
                </p>
            </div>
            <div class="text5des" style="bottom: -10vw;" bind:this={text5des}>
                <p>Upskilling of underrepresented Communities using OPUS</p>
                <br />
                <p>Application of OPUS in HPC and Scientific Computing</p>
                <br />
                <p>Computer Science Upskilling through Gamification</p>
            </div>
        </section1>
    {/if}

    {#if flag2 === false}
        <section2
            in:fade
            style="position: absolute; transition-duration: 1s;top: 0;z-index:4;width: 100%;"
            bind:this={section2}
        >
            <div class="bgDiv" role="presentation" on:click={next}>
                <img
                    id="tractionbg"
                    src="/images/traction/competition.png"
                    alt=""
                />

                <div class="whitediv" bind:this={whitediv}>
                    <p class="whitedivtext" bind:this={whitedivtext1}>
                        GAMING - TECH
                    </p>
                    <p class="whitedivtext2" bind:this={whitedivtext2}>
                        GENERATING AI
                    </p>
                    <p class="whitedivtext3" bind:this={whitedivtext3}>
                        TRADITIONAL
                        <br />
                        PUBLISHER
                    </p>
                </div>

                <div class="tableheading" style="opacity: {sec2divsOpacity};">
                    <p>
                        Generative <br />
                        AI
                    </p>
                    <p
                        style="
            margin-left: 0.1vw;
            "
                    >
                        Traditional DCC
                        <br />
                        Workfl0w
                    </p>
                    <p
                        style="
            margin-left: -0.24vw;
            "
                    >
                        Photo
                        <br />
                        Realism
                    </p>
                    <p
                        style="
            margin-left: 0.1vw;
            "
                    >
                        Text to
                        <br />
                        Video Games
                    </p>
                    <p
                        style="
            margin-left: -1.9vw;
            "
                    >
                        Instant
                        <br />
                        Publishing
                    </p>
                    <p
                        style="
            margin-left: -1.8vw;
            "
                    >
                        Usable On
                        <br />
                        Smartphones
                    </p>
                    <p
                        style="
            margin-left: -3.0vw;
            "
                    >
                        Usable by
                        <br />
                        Non - Technical
                    </p>
                </div>

                <div class="tableheading2" style="opacity: {sec2divsOpacity2};">
                    <p>
                        Training
                        <br />
                        TIme / Cost
                    </p>
                    <p
                        style="
            margin-left: 2vw;
            "
                    >
                        Traditional

                        <br />
                        DCC Assets
                    </p>
                    <p
                        style="
            margin-left: 3vw;
            "
                    >
                        Scalability
                    </p>
                    <p
                        style="
            margin-left: 2vw;
            "
                    >
                        Applications
                    </p>
                    <p
                        style="
            margin-left: 2vw;
            "
                    >
                        Business
                        <br />
                        Model / TAM
                    </p>
                </div>

                <div class="tableheading3" style="opacity: {sec2divsOpacity3};">
                    <p>
                        Time to
                        <br />
                        Production
                    </p>
                    <p
                        style="
            margin-left: 1vw;
        "
                    >
                        Scalability
                    </p>
                    <p>
                        Usable on
                        <br />
                        Smartphones
                    </p>
                    <p>Video Games</p>
                    <p>
                        Interactive
                        <br />
                        Experiences
                    </p>
                    <p>Simulation</p>
                    <p>Live Streaming</p>
                    <p>
                        Live
                        <br />
                        Personalization
                    </p>
                    <p>
                        Live
                        <br />
                        Contextual Ads
                    </p>
                </div>

                <div class="rowheading" style="opacity: {sec2divsOpacity};">
                    <p>UNITY3D</p>
                    <p>UNREALENGINE</p>
                    <p>GODOT</p>
                    <p>O3DE</p>
                </div>
                <div
                    class="rowheading2"
                    style="opacity: {sec2divsOpacity2};"
                    bind:this={rowheading2}
                >
                    <p>GENERATIVE AI STARTUPS</p>
                </div>
                <div class="rowheading3" style="opacity: {sec2divsOpacity3};">
                    <p>
                        TRADITIONAL<br />
                        GAMING STUDIOS
                    </p>
                </div>
                <div class="boxlogo" bind:this={boxlogo}>
                    <img
                        src="/images/traction/opus.png"
                        width="100%"
                        height="100%"
                        alt=""
                    />
                </div>
                <div class="box" bind:this={boxdiv}>
                    <div class="tabledes2" style="opacity: {sec2divsOpacity2};">
                        <p style="width:10vw;">
                            Long and <br /> expensive training with no guarantee
                            of improvement.
                        </p>
                        <p
                            style="
                margin-left: 1.5vw;
                margin-top: 1.5vw;
                "
                        >
                            NO
                        </p>
                        <p
                            style="
                width: 9vw;
                margin-left: 4.5vw;
                "
                        >
                            Unpredictable results. Character limit with
                            exponential computing cost
                        </p>
                        <p
                            style="
                margin-left: -1.5vw;
                width:10.406vw;
                "
                        >
                            Stock Images Website Background Videos
                        </p>
                        <p
                            style="
                margin-left: -1.7vw;
                width:9.406vw;
                "
                        >
                            API billing/ Content marketing B2B niche
                        </p>
                    </div>

                    <div class="tabledes4" style="opacity: {sec2divsOpacity3};">
                        <p
                            style="
                font-size: 1.563vw;
                font-weight: 600;
                margin-top: 1.3vw;
            "
                        >
                            1 Year +
                        </p>
                        <p
                            style="
                width: 5.729vw;
                margin-left: 2vw;
                font-size: 1.042vw;
                font-weight: 600;
                "
                        >
                            Highly trained talent pool limit.
                        </p>
                        <img
                            style="
                margin-left: 4vw;
            "
                            src="/images/traction/crossred.svg"
                            alt=""
                        />
                        <img
                            style="
                margin-left: 8vw;
            "
                            src="/images/traction/tickgreen.svg"
                            alt=""
                        />

                        <img
                            style="
                margin-left: 6.5vw;
            "
                            src="/images/traction/tickgreen.svg"
                            alt=""
                        />

                        <img
                            style="
            margin-left: 6vw;
        "
                            src="/images/traction/crossred.svg"
                            alt=""
                        />

                        <img
                            style="
            margin-left: 8vw;
        "
                            src="/images/traction/crossred.svg"
                            alt=""
                        />

                        <img
                            style="
            margin-left: 8vw;
        "
                            src="/images/traction/crossred.svg"
                            alt=""
                        />

                        <img
                            style="
            margin-left: 7.5vw;
        "
                            src="/images/traction/crossred.svg"
                            alt=""
                        />
                    </div>

                    <div
                        class="boximg"
                        style="transition-Duration:1s; opacity:{sec2divsOpacity};"
                    >
                        <img
                            src="/images/traction/box.png"
                            width="100%"
                            height="100%"
                            alt=""
                        />
                    </div>
                    <div class="tickdiv" bind:this={tickdiv}>
                        <div
                            class="tabledes3"
                            style="opacity: {sec2divsOpacity2};"
                        >
                            <p style="width:10vw;">
                                Consumer grade PCs are used for training.
                            </p>
                            <p
                                style="
                    margin-left: -2vw;
                    font-size: 1.563vw;
                    margin-top: 1.5vw;
                    "
                            >
                                SUPPORTED
                            </p>
                            <p
                                style="
                    width:9vw;
                    "
                            >
                                Reproducible results. Unlimited characters with
                                linear computing cost
                            </p>
                            <p
                                style="
                    margin-left: -1.5vw;
                    width:11.406vw;
                    "
                            >
                                Gaming Simulation Interactive Experiences Live
                                streaming Personalization and Contextual ad
                            </p>
                            <p
                                style="
                    margin-left: -2.7vw;
                    width:9.406vw;
                    "
                            >
                                Publishing. All B2B and D2C segment
                            </p>
                        </div>

                        <div
                            class="tabledes5"
                            style="opacity: {sec2divsOpacity3};"
                        >
                            <p
                                style="
                    font-size: 1.563vw;
                    font-weight: 900;
                    margin-top: 1.3vw;
                "
                            >
                                1 Week
                            </p>
                            <p
                                style="
                    width: 5.729vw;
                    margin-left: 2vw;
                    font-size: 1.042vw;
                    font-weight: 600;
                    "
                            >
                                Everyone can create, derive, extend.
                            </p>
                            <img
                                style="
                    margin-left: 4vw;
                "
                                src="/images/traction/tickblue.svg"
                                alt=""
                            />

                            <img
                                style="
                    margin-left: 7.8vw;
                "
                                src="/images/traction/tickblue.svg"
                                alt=""
                            />

                            <img
                                style="
                    margin-left: 6.5vw;
                "
                                src="/images/traction/tickblue.svg"
                                alt=""
                            />

                            <img
                                style="
                margin-left: 6vw;
            "
                                src="/images/traction/tickblue.svg"
                                alt=""
                            />

                            <img
                                style="
                margin-left: 7.3vw;
            "
                                src="/images/traction/tickblue.svg"
                                alt=""
                            />

                            <img
                                style="
                margin-left: 7.6vw;
            "
                                src="/images/traction/tickblue.svg"
                                alt=""
                            />

                            <img
                                style="
                margin-left: 7vw;
            "
                                src="/images/traction/tickblue.svg"
                                alt=""
                            />
                        </div>
                    </div>

                    <div class="tick" style="opacity:{sec2divsOpacity};">
                        <div>
                            <img
                                src="/images/traction/tick.png"
                                width="100%"
                                height="100%"
                                alt=""
                            />
                        </div>

                        <div>
                            <img
                                src="/images/traction/tick.png"
                                width="100%"
                                height="100%"
                                alt=""
                            />
                        </div>

                        <div style="margin-left: -0.1vw;">
                            <img
                                src="/images/traction/tick.png"
                                width="100%"
                                height="100%"
                                alt=""
                            />
                        </div>

                        <div style="margin-left: -1.69vw;">
                            <img
                                src="/images/traction/tick.png"
                                width="100%"
                                height="100%"
                                alt=""
                            />
                        </div>

                        <div style="margin-left: -2.4vw;">
                            <img
                                src="/images/traction/tick.png"
                                width="100%"
                                height="100%"
                                alt=""
                            />
                        </div>

                        <div style="margin-left: -2.5vw;">
                            <img
                                src="/images/traction/tick.png"
                                width="100%"
                                height="100%"
                                alt=""
                            />
                        </div>

                        <div style="margin-left: -2.2vw;">
                            <img
                                src="/images/traction/tick.png"
                                width="100%"
                                height="100%"
                                alt=""
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section2>
    {/if}
</div>

<style>
    p {
        font-family: "Montserrat";
        margin: 0;
    }
    .maindiv {
        overflow: hidden;
        position: relative;
        background-color: #101428;
        height: 100vh;
    }
    .bgDiv {
        height: 100vh;
        overflow: hidden;
        width: 100%;
        background-size: cover;
        background-repeat: no-repeat;
        position: relative;
    }
    .traction {
        font-size: 18.519vh;
        font-weight: 900;
        color: #ff007f;
        position: absolute;
        z-index: 1;
        top: -40vh;
        left: 32.5vw;
        transition-duration: 2s;
    }
    .elipse {
        width: 43.703vw;
        height: 43.703vw;
        border-radius: 50%;
        background-color: transparent;
        border: 6.5vw solid #3e3c3c;
        position: absolute;
        left: 22vw;
        bottom: -31vw;
        transition-duration: 1s;
        z-index: 5;
    }
    .hourglass {
        position: absolute;
        width: 2.708vw;
        height: 3.594vw;
        z-index: 5;
        bottom: 5.365vw;
        left: 26vw;
    }
    .yellow-div {
        width: 10vw;
        height: 10vw;
        position: absolute;
        top: 3vw;
        left: -4.1vw;
        transform: rotate(14deg);
        z-index: 0;
        transition-duration: 2s;
    }
    .person {
        position: absolute;
        width: 3.698vw;
        height: 4.142vw;
        left: 33.4vw;
        z-index: 5;
        bottom: 15.8vw;
    }
    .calender {
        position: absolute;
        width: 3.698vw;
        height: 3.698vw;
        left: 48.6vw;
        z-index: 5;
        bottom: 20.8vw;
    }
    .people {
        position: absolute;
        width: 3.75vw;
        height: 3.75vw;
        left: 64.5vw;
        z-index: 5;
        bottom: 15.8vw;
    }
    .scroll {
        position: absolute;
        width: 3.854vw;
        height: 3.854vw;
        z-index: 5;
        bottom: 5.365vw;
        left: 71.24vw;
    }
    .heading {
        font-size: 3.125vw;
        font-weight: 900;
    }
    .description {
        font-size: 1.563vw;
        font-weight: 800;
    }
    .text1 {
        position: absolute;
        bottom: 7.3vw;
        left: 11vw;
        line-height: 2vw;
        scale: 1;
        color: #3e3e3e;
        transition-duration: 2s;
    }
    .text1After {
        color: white;
        scale: 1.2;
        position: absolute;
        bottom: 7.3vw;
        left: 11vw;
        line-height: 2vw;
        transition-duration: 2s;
    }
    .text2 {
        position: absolute;
        bottom: 18.6vw;
        left: 25vw;
        line-height: 2vw;
        scale: 1;
        color: #3e3e3e;
        transition-duration: 2s;
    }
    .text2After {
        color: white;
        scale: 1.2;
        position: absolute;
        bottom: 18.6vw;
        left: 25vw;
        line-height: 2vw;
        transition-duration: 2s;
    }

    .text3 {
        position: absolute;
        bottom: 26.6vw;
        left: 43vw;
        scale: 1;
        color: #3e3e3e;
        transition-duration: 2s;
    }
    .text3After {
        color: white;
        scale: 1.2;
        position: absolute;
        bottom: 26.6vw;
        left: 43vw;
        transition-duration: 2s;
    }
    .text4 {
        position: absolute;
        bottom: 21.6vw;
        left: 71vw;
        scale: 1;
        color: #3e3e3e;
        transition-duration: 2s;
    }
    .text4After {
        color: white;
        scale: 1.2;
        position: absolute;
        bottom: 21.6vw;
        left: 71vw;
        transition-duration: 2s;
    }
    .text5 {
        position: absolute;
        bottom: 5.3vw;
        left: 79.111vw;
        line-height: 1vw;
        scale: 1;
        color: #3e3e3e;
        transition-duration: 2s;
    }
    .text5After {
        color: white;
        scale: 1.2;
        position: absolute;
        bottom: 11.9vw;
        left: 79.111vw;
        line-height: 1vw;
        transition-duration: 2s;
    }
    .text4des {
        position: absolute;
        bottom: 20.6vw;
        left: 71vw;
        color: white;
        font-weight: 500;
        transition-duration: 2s;
    }
    .text5des {
        color: white;
        left: 79vw;
        position: absolute;
        font-size: 0.833vw;
        width: 18.802vw;
        transition-duration: 2s;
    }

    .competition {
        font-size: 13.889vh;
        font-weight: 900;
        color: #ff007f;
        position: absolute;
        top: -20vh;
        left: 38.5vw;
        transition-duration: 2s;
        z-index: 5;
    }
    .whitediv {
        width: 21.458vw;
        height: 3.906vw;
        background-color: white;
        left: 0vw;
        position: absolute;
        bottom: 30.427vw;
        border-top-right-radius: 1.042vw;
        border-bottom-right-radius: 1.042vw;
        transition-duration: 1s;
    }
    .whitedivtext {
        font-size: 2.083vw;
        font-weight: 900;
        color: #ff007f;
        position: absolute;
        padding: 0.7vw;
        left: 0vw;
        transition-duration: 1s;
    }
    .whitedivtext2 {
        font-size: 2.083vw;
        font-weight: 900;
        color: #ff007f;
        position: absolute;
        padding: 0.7vw;
        left: -20vw;
        transition-duration: 1s;
    }
    .whitedivtext3 {
        font-size: 1.563vw;
        font-weight: 900;
        color: #ff007f;
        position: absolute;
        line-height: 1.233vw;
        padding: 0.7vw;
        left: -20vw;
        transition-duration: 1s;
    }
    .box {
        width: 74.74vw;
        height: 29.948vw;
        position: absolute;
        bottom: 0.219vw;
        background-color: #0e112d;
        left: 22vw;
        border-radius: 2.083vw;
        transition-duration: 1s;
    }
    .tick {
        display: flex;
        position: absolute;
        bottom: 5.1vw;
        width: 86.771vw;
        height: 1.771vw;
        gap: 10.2vw;
        left: 5vw;
        bottom: 3.7vw;
        z-index: 4;
        transition-duration: 1s;
    }
    .tickdiv {
        width: 0vw;
        height: 3.958vw;
        position: absolute;
        background-color: #4ecb71;
        z-index: 1;
        bottom: 2.6vw;
        left: -2.9vw;
        transition-duration: 3s;
    }
    .tableheading {
        display: flex;
        position: absolute;
        font-size: 0.938vw;
        bottom: 31vw;
        line-height: 0.938vw;
        color: white;
        left: 25.46vw;
        text-align: center;
        gap: 5.8vw;
        width: 106vw;
        transition-duration: 1s;
    }
    .tableheading2 {
        display: flex;
        position: absolute;
        font-size: 1.042vw;
        bottom: 31vw;
        line-height: 0.938vw;
        color: white;
        left: 28.969vw;
        text-align: center;
        gap: 5.8vw;
        width: 106vw;
        font-weight: 600;
        transition-duration: 1s;
    }
    .tableheading3 {
        display: flex;
        position: absolute;
        font-size: 0.938vw;
        bottom: 31vw;
        line-height: 0.938vw;
        color: white;
        left: 19.969vw;
        text-align: center;
        /* gap: 0.5vw; */
        justify-content: space-between;
        width: 77vw;
        font-weight: 300;
        transition-duration: 1s;
    }
    .tabledes4 {
        display: flex;
        position: absolute;
        bottom: 21vw;
        color: white;
        left: 2.969vw;
        text-align: center;
        gap: 0.5vw;
        width: 106vw;
        transition-duration: 1s;
    }
    .tabledes5 {
        display: flex;
        position: absolute;
        bottom: 5vw;
        color: #010422;
        left: 2.969vw;
        text-align: center;
        gap: 0.5vw;
        width: 106vw;
        transition-duration: 1s;
    }
    .tabledes2 {
        display: flex;
        position: absolute;
        font-size: 0.938vw;
        bottom: 22vw;
        line-height: 0.938vw;
        color: white;
        left: 5.3vw;
        text-align: center;
        gap: 5.8vw;
        width: 106vw;
        font-weight: 700;
        transition-duration: 1s;
    }
    .tabledes3 {
        display: flex;
        position: absolute;
        font-size: 0.938vw;
        bottom: 5vw;
        line-height: 0.938vw;
        color: black;
        left: 5.3vw;
        text-align: center;
        gap: 5.8vw;
        width: 106vw;
        font-weight: 900;
        transition-duration: 1s;
    }
    .rowheading {
        font-size: 2.083vw;
        position: absolute;
        bottom: 7.4vw;
        left: 2vw;
        color: white;
        text-align: end;
        font-weight: 100;
        line-height: 5vw;
        transition-duration: 1s;
    }
    .rowheading2 {
        font-size: 1.563vw;
        position: absolute;
        bottom: 23.4vw;
        left: 9vw;
        width: 11.094vw;
        color: white;
        font-weight: 900;
        line-height: 1.514vw;
        transition-duration: 1s;
    }
    .rowheading3 {
        font-size: 1.563vw;
        position: absolute;
        bottom: 23.4vw;
        left: 3.9vw;
        width: 11.094vw;
        text-align: end;
        color: white;
        font-weight: 900;
        line-height: 1.514vw;
        transition-duration: 1s;
    }
    .boxlogo {
        width: 9.74vw;
        position: absolute;
        bottom: 2.9vw;
        left: 9.3vw;
        height: 3.8vw;
        transition-duration: 1s;
    }
</style>
